module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMobile) ? _c('div', {
    staticClass: "hamburger-menu"
  }, [(!_vm.isOpen) ? _c('button', {
    staticClass: "hamburger-menu__trigger icon",
    class: {
      open: _vm.isOpen
    },
    attrs: {
      "aria-expanded": _vm.isOpen ? 'true' : 'false',
      "aria-label": _vm.locale.t('label_toggle_navigation_menu')
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "hamburger-menu__backdrop",
    on: {
      "click": _vm.toggleMenu
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "hamburger-menu__panel fade-in"
  }, [_c('div', {
    staticClass: "nav-close-div"
  }, [_c('div', {
    staticClass: "nav-spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-close-div-right"
  }, [_c('button', {
    staticClass: "hamburger-menu__close icon-close",
    attrs: {
      "aria-label": _vm.locale.t('label_close_navigation_menu')
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "ti-close nav-close-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-nav-container grid-nav-container--open"
  }, [_vm._l((_vm.tabs), function(item, index) {
    return (item.role.includes(_vm.myRole)) ? _c('div', {
      key: index,
      staticClass: "grid-nav-item",
      class: {
        'grid-nav-item--active': _vm.isActive(item)
      },
      on: {
        "click": function($event) {
          return _vm.onClickTab(item.id)
        }
      }
    }, [_c('i', {
      class: item.iconClass
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t(item.localizationId)))]), _vm._v(" "), (item.showBalance) ? _c('b', {
      style: (_vm.currentBalance > 0 ? 'color: green;' : _vm.currentBalance === 0 ? 'color: white;' : 'color: red;')
    }, [_vm._v(" (" + _vm._s(_vm.currentBalance) + "  €)")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "grid-nav-item grid-nav-item--theme",
    class: {
      'grid-nav-item--active': _vm.themeMode === 'light'
    },
    on: {
      "click": _vm.toggleThemeMode
    }
  }, [_c('i', {
    staticClass: "ti-light-bulb"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.themeMode === 'light' ? _vm.locale.t('label_light_theme') : _vm.locale.t('label_dark_theme')))]), _vm._v(" "), _c('span', {
    staticClass: "grid-nav-theme-switch",
    class: _vm.themeMode === 'light' ? 'is-on' : 'is-off'
  }, [_c('span', {
    staticClass: "grid-nav-theme-switch__dot"
  })])]), _vm._v(" "), (this.$sessionService.getAccessToken() != null && _vm.rightTabs.includes('MY_MEMBER') && _vm.myRole === 'ROLE_USER') ? _c('div', {
    key: '103',
    staticClass: "grid-nav-item",
    on: {
      "click": _vm.myPayments
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t("label_membership")))]), _vm._v(" "), (_vm.moreThan50Trainings()) ? _c('i', {
    staticClass: "my-badge-new badge-lg",
    style: (_vm.getTrainingsStyle())
  }, [_vm._v("∞")]) : _vm._e(), _vm._v(" "), (!_vm.moreThan50Trainings()) ? _c('i', {
    staticClass: "my-badge-new",
    style: (_vm.getTrainingsStyleNumber())
  }, [_vm._v(_vm._s(_vm.restOfTraining))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() != null) ? _c('div', {
    key: '104',
    staticClass: "grid-nav-item",
    class: {
      'grid-nav-item--active': _vm.isActive({
        route: '/profile'
      })
    },
    on: {
      "click": _vm.profile
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t("label_account")))])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() != null) ? _c('div', {
    key: '105',
    staticClass: "grid-nav-item",
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t("label_logout")))])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() == null) ? _c('div', {
    key: '106',
    staticClass: "grid-nav-item",
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t("label_login")))])]) : _vm._e()], 2), _vm._v(" "), (this.$sessionService.getAccessToken() != null && _vm.rightTabs.includes('NUMBER_OF_TRAININGS') && _vm.myRole === 'ROLE_USER') ? _c('div', {
    staticClass: "grid-nav-item-info"
  }, [_c('i', {
    staticClass: "ti-info-alt",
    style: (_vm.paymentStyle)
  }), _vm._v(" "), _c('p', {
    style: (_vm.paymentStyle)
  }, [_vm._v(_vm._s(_vm.payment))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hamburger-menu__panel-end-spacer"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "menu",
    class: {
      show: _vm.isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "app-shell-nav",
    class: {
      'app-shell-nav--collapsed': _vm.isSidebarCollapsed
    }
  }, [(_vm.desktopNavMode === 'sidebar') ? _c('aside', {
    staticClass: "app-shell-sidebar"
  }, [_c('div', {
    staticClass: "app-shell-sidebar__brand"
  }, [_c('img', {
    staticClass: "app-shell-sidebar__brand-logo",
    attrs: {
      "src": _vm.logoImage,
      "alt": _vm.companyName
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "app-shell-sidebar__collapse",
    attrs: {
      "title": _vm.isSidebarCollapsed ? _vm.locale.t('label_expand_sidebar') : _vm.locale.t('label_collapse_sidebar')
    },
    on: {
      "click": _vm.toggleSidebarMode
    }
  }, [_c('span', {
    staticClass: "app-shell-sidebar__collapse-arrow"
  }, [_vm._v(_vm._s(_vm.isSidebarCollapsed ? '›' : '‹'))])])]), _vm._v(" "), _c('ul', {
    staticClass: "app-shell-sidebar__menu"
  }, _vm._l((_vm.tabs), function(item) {
    return (item.role.includes(_vm.myRole)) ? _c('li', {
      staticClass: "dropdown app-shell-sidebar__item",
      class: _vm.isActive(item) ? 'dropdown-menu-item-active' : 'dropdown-menu-item',
      on: {
        "mouseover": function($event) {
          item.subItems ? _vm.showSubMenu(item.id) : null
        },
        "mouseleave": function($event) {
          item.subItems ? _vm.hideSubMenu(item.id) : null
        }
      }
    }, [_c('a', {
      staticClass: "btn-rotate dropdown-toggle nav-link app-shell-sidebar__link",
      attrs: {
        "title": _vm.locale.t(item.localizationId),
        "role": "button"
      },
      on: {
        "click": function($event) {
          item.subItems != null && item.subItems.length > 0 ? _vm.onClickTabFromParent(item) : _vm.onClickTab(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "app-shell-sidebar__icon",
      class: item.iconClass
    }), _vm._v(" "), _c('p', {
      staticClass: "app-shell-sidebar__label"
    }, [_vm._v("\n                " + _vm._s(_vm.locale.t(item.localizationId)) + "\n                "), _c('i', {
      class: item.subItems != null && item.subItems.length > 1 ? 'ti-arrow-circle-down app-shell-sidebar__arrow' : null
    }), _vm._v(" "), (item.showBalance) ? _c('b', {
      style: (_vm.currentBalance > 0 ? 'color: green;' : _vm.currentBalance === 0 ? 'color: white;' : 'color: red;')
    }, [_vm._v(" (" + _vm._s(_vm.currentBalance) + "  €)")]) : _vm._e()])]), _vm._v(" "), (item.subItems && item.subItems.length > 1) ? _c('ul', {
      staticClass: "dropdown-menu app-shell-sidebar__submenu",
      style: ({
        display: item.isOpen ? 'block' : 'none'
      })
    }, _vm._l((item.subItems), function(subItem) {
      return _c('li', {
        key: subItem.id,
        class: _vm.isActive(subItem) ? 'dropdown-menu-item-active' : 'dropdown-menu-item'
      }, [_c('a', {
        staticClass: "app-shell-sidebar__sublink",
        attrs: {
          "title": _vm.locale.t(subItem.localizationId)
        },
        on: {
          "click": function($event) {
            return _vm.onClickTab(subItem.id)
          }
        }
      }, [_c('i', {
        staticClass: "app-shell-sidebar__subicon",
        class: subItem.iconClass
      }), _vm._v("\n                  " + _vm._s(_vm.locale.t(subItem.localizationId)) + "\n                ")])])
    }), 0) : _vm._e()]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "app-shell-sidebar__footer"
  }, [(this.$sessionService.getAccessToken() != null && _vm.rightTabs.includes('NUMBER_OF_TRAININGS') && _vm.myRole === 'ROLE_USER' && _vm.showMembershipCard) ? _c('div', {
    staticClass: "app-shell-sidebar__status"
  }, [_c('div', {
    staticClass: "app-shell-sidebar__status-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_membership")))]), _vm._v(" "), _c('div', {
    staticClass: "app-shell-sidebar__status-line"
  }, [_c('span', {
    staticClass: "app-shell-sidebar__status-payment",
    style: (_vm.paymentStyle)
  }, [_vm._v(_vm._s(_vm.payment))])]), _vm._v(" "), (_vm.showRestTrainings) ? _c('div', {
    staticClass: "app-shell-sidebar__status-badge"
  }, [_c('div', {
    staticClass: "app-shell-sidebar__trainings-pill",
    class: _vm.restOfTraining === 0 ? 'is-danger' : _vm.restOfTraining <= 3 ? 'is-warn' : 'is-ok'
  }, [_c('i', {
    staticClass: "ti-bar-chart"
  }), _vm._v(" "), (_vm.moreThan50Trainings()) ? _c('b', [_vm._v("∞")]) : _vm._e(), _vm._v(" "), (!_vm.moreThan50Trainings()) ? _c('b', [_vm._v(_vm._s(_vm.restOfTraining))]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "app-shell-sidebar__actions"
  }, [_c('li', {
    staticClass: "app-shell-sidebar__action app-shell-sidebar__action--theme",
    class: _vm.themeMode === 'light' ? 'dropdown-menu-item-active' : 'dropdown-menu-item'
  }, [_c('a', {
    staticClass: "app-shell-sidebar__action-link app-shell-sidebar__theme-toggle",
    on: {
      "click": _vm.toggleThemeMode
    }
  }, [_c('i', {
    staticClass: "ti-light-bulb"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.themeMode === 'light' ? _vm.locale.t('label_light_theme') : _vm.locale.t('label_dark_theme')))]), _vm._v(" "), _c('span', {
    staticClass: "app-shell-sidebar__theme-switch",
    class: _vm.themeMode === 'light' ? 'is-on' : 'is-off'
  }, [_c('span', {
    staticClass: "app-shell-sidebar__theme-switch-dot"
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "app-shell-sidebar__action"
  }, [_c('a', {
    staticClass: "app-shell-sidebar__action-link",
    on: {
      "click": function($event) {
        return _vm.setDesktopNavMode('topbar')
      }
    }
  }, [_c('i', {
    staticClass: "ti-layout-grid2-alt"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t('label_switch_to_topbar')))])])]), _vm._v(" "), (this.$sessionService.getAccessToken() != null && _vm.rightTabs.includes('MY_MEMBER') && _vm.myRole === 'ROLE_USER' && _vm.showMembershipCard) ? _c('li', {
    staticClass: "app-shell-sidebar__action",
    class: _vm.isActive({
      route: '/my-payments'
    }) ? 'dropdown-menu-item-active' : 'dropdown-menu-item'
  }, [_c('a', {
    staticClass: "app-shell-sidebar__action-link",
    on: {
      "click": _vm.myPayments
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_membership")))])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() != null) ? _c('li', {
    staticClass: "app-shell-sidebar__action",
    class: _vm.isActive({
      route: '/profile'
    }) ? 'dropdown-menu-item-active' : 'dropdown-menu-item'
  }, [_c('a', {
    staticClass: "app-shell-sidebar__action-link",
    on: {
      "click": _vm.profile
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_account")))])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() != null) ? _c('li', {
    staticClass: "app-shell-sidebar__action"
  }, [_c('a', {
    staticClass: "app-shell-sidebar__action-link",
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_logout")))])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() == null) ? _c('li', {
    staticClass: "app-shell-sidebar__action"
  }, [_c('a', {
    staticClass: "app-shell-sidebar__action-link",
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_login")))])])]) : _vm._e()])])]) : _c('div', {
    staticClass: "app-shell-topbar"
  }, [_c('div', {
    staticClass: "app-shell-topbar__inner"
  }, [_c('div', {
    staticClass: "app-shell-topbar__brand"
  }, [_c('img', {
    staticClass: "app-shell-topbar__brand-logo",
    attrs: {
      "src": _vm.logoImage,
      "alt": _vm.companyName
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "app-shell-topbar__menu"
  }, _vm._l((_vm.tabs), function(item) {
    return (item.role.includes(_vm.myRole)) ? _c('li', {
      staticClass: "dropdown app-shell-topbar__item",
      class: _vm.isActive(item) ? 'dropdown-menu-item-active' : 'dropdown-menu-item',
      on: {
        "mouseover": function($event) {
          item.subItems ? _vm.showTopbarSubMenu(item, $event) : null
        },
        "mouseleave": function($event) {
          item.subItems ? _vm.scheduleHideTopbarSubmenu() : null
        }
      }
    }, [_c('a', {
      staticClass: "btn-rotate dropdown-toggle nav-link app-shell-topbar__link",
      attrs: {
        "title": _vm.locale.t(item.localizationId),
        "role": "button"
      },
      on: {
        "click": function($event) {
          item.subItems != null && item.subItems.length > 0 ? _vm.onClickTabFromParent(item) : _vm.onClickTab(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "app-shell-topbar__icon",
      class: item.iconClass
    }), _vm._v(" "), _c('p', {
      staticClass: "app-shell-topbar__label"
    }, [_vm._v("\n                  " + _vm._s(_vm.locale.t(item.localizationId)) + "\n                  "), _c('i', {
      class: item.subItems != null && item.subItems.length > 1 ? 'ti-arrow-circle-down app-shell-topbar__arrow' : null
    }), _vm._v(" "), (item.showBalance) ? _c('b', {
      style: (_vm.currentBalance > 0 ? 'color: green;' : _vm.currentBalance === 0 ? 'color: white;' : 'color: red;')
    }, [_vm._v(" (" + _vm._s(_vm.currentBalance) + "  €)")]) : _vm._e()])])]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.topbarSubmenuItem && _vm.topbarSubmenuItem.subItems && _vm.topbarSubmenuItem.subItems.length > 1) ? _c('ul', {
    staticClass: "app-shell-topbar__submenu-flyout",
    style: (_vm.topbarSubmenuStyle),
    on: {
      "mouseenter": _vm.onTopbarSubmenuEnter,
      "mouseleave": _vm.onTopbarSubmenuLeave
    }
  }, _vm._l((_vm.topbarSubmenuItem.subItems), function(subItem) {
    return _c('li', {
      key: subItem.id,
      class: _vm.isActive(subItem) ? 'dropdown-menu-item-active' : 'dropdown-menu-item'
    }, [_c('a', {
      staticClass: "app-shell-topbar__sublink",
      attrs: {
        "title": _vm.locale.t(subItem.localizationId)
      },
      on: {
        "click": function($event) {
          return _vm.onTopbarSubItemClick(subItem.id)
        }
      }
    }, [_c('i', {
      staticClass: "app-shell-topbar__subicon",
      class: subItem.iconClass
    }), _vm._v("\n                " + _vm._s(_vm.locale.t(subItem.localizationId)) + "\n              ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-shell-topbar__actions"
  }, [_c('div', {
    staticClass: "app-shell-topbar__settings",
    class: {
      'is-open': _vm.topbarActionsOpen
    }
  }, [_c('a', {
    staticClass: "app-shell-topbar__settings-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTopbarActions.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "ti-settings"
  }), _vm._v(" "), _c('i', {
    staticClass: "ti-angle-down app-shell-topbar__settings-arrow"
  })]), _vm._v(" "), (_vm.topbarActionsOpen) ? _c('ul', {
    staticClass: "app-shell-topbar__settings-menu"
  }, [_c('li', [_c('a', {
    staticClass: "app-shell-topbar__settings-link",
    on: {
      "click": function($event) {
        return _vm.setDesktopNavMode('sidebar')
      }
    }
  }, [_c('i', {
    staticClass: "ti-view-list"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t('label_switch_to_sidebar')))])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "app-shell-topbar__settings-link",
    on: {
      "click": function($event) {
        _vm.toggleThemeMode();
        _vm.closeTopbarActions()
      }
    }
  }, [_c('i', {
    staticClass: "ti-light-bulb"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.themeMode === 'light' ? _vm.locale.t('label_light_theme') : _vm.locale.t('label_dark_theme')))])])]), _vm._v(" "), (this.$sessionService.getAccessToken() != null && _vm.rightTabs.includes('MY_MEMBER') && _vm.myRole === 'ROLE_USER' && _vm.showMembershipCard) ? _c('li', [_c('a', {
    staticClass: "app-shell-topbar__settings-link",
    on: {
      "click": function($event) {
        _vm.myPayments();
        _vm.closeTopbarActions()
      }
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_membership")))])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() != null) ? _c('li', [_c('a', {
    staticClass: "app-shell-topbar__settings-link",
    on: {
      "click": function($event) {
        _vm.profile();
        _vm.closeTopbarActions()
      }
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_account")))])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() != null) ? _c('li', [_c('a', {
    staticClass: "app-shell-topbar__settings-link",
    on: {
      "click": function($event) {
        _vm.signOut();
        _vm.closeTopbarActions()
      }
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_logout")))])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() == null) ? _c('li', [_c('a', {
    staticClass: "app-shell-topbar__settings-link",
    on: {
      "click": function($event) {
        _vm.signOut();
        _vm.closeTopbarActions()
      }
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t("label_login")))])])]) : _vm._e()]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "show": _vm.changePasswordModalVisible
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-414b9d9b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/TopNavbar.vue
// module id = 750
// module chunks = 0